'use strict';
require('./sticker-category-widget');
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.stickersSidebarWidget = function (params) {
	const {stickersEditorModel} = params;
	if (!stickersEditorModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const widget = this,
			stickersForMetadataSelector = widget.find('[data-mm-role~="stickers-for-metadata-selector"]'),
			stickersForActivatedSelector = widget.find('[data-mm-role~="stickers-for-activated-selector"]'),
			stickersForMapSelector = widget.find('[data-mm-role~="stickers-for-map-selector"]'),
			selectorCategoryTemplate = widget.find('[data-mm-role~="category-template"]').detach(),
			removeAllFromActivated = widget.find('[data-mm-role~="remove-all-from-activated"]');
		widget.on('show', () => {
			stickersEditorModel.setActive(true);
			widget.find('[data-mm-role~="stickers-scroll-container"]').domElements[0].scrollTop = 0;
		});
		widget.on('hide', () => {
			stickersEditorModel.setActive(false);
		});
		removeAllFromActivated.click(function () {
			stickersEditorModel.removeAllStickersFromActivatedNodes();
		});
		stickersEditorModel.addEventListener('stickers-for-metadata-loaded', () => {
			stickersForMetadataSelector.find('[data-mm-role~="category-template"]').remove();
			stickersEditorModel.getMetadataCategories().forEach((category) => {
				selectorCategoryTemplate.clone().appendTo(stickersForMetadataSelector).stickerCategoryWidget({stickersEditorModel, category, action: 'addStickerToActivatedNodes'});
			});
		});
		stickersEditorModel.addEventListener('stickers-for-activated-loaded', (category) => {
			stickersForActivatedSelector.find('[data-mm-role~="category-template"]').remove();
			selectorCategoryTemplate.clone().appendTo(stickersForActivatedSelector).stickerCategoryWidget({stickersEditorModel, category, action: 'removeStickerFromActivatedNodes', additionalClass: 'remove-sticker'});
		});

		stickersEditorModel.addEventListener('stickers-for-map-loaded', (category) => {
			stickersForMapSelector.find('[data-mm-role~="category-template"]').remove();
			selectorCategoryTemplate.clone().appendTo(stickersForMapSelector).stickerCategoryWidget({stickersEditorModel, category, action: 'addStickerToActivatedNodes'});
		});
	});
};
